import React, { useEffect, useRef } from 'react';

import './bookSuccess.scss';

import { useLocation, useNavigate } from 'react-router-dom';

import CustomVideoPlayer from '../../common-components/CustomVideoPlayer/CustomVideoPlayer';
import LeftArrow from '../../Icons/icons/LeftArrow';

const BookingSuccess = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const videoContainerRef = useRef();

  return (
    <div className="strategy-success-container">
      <div className="strategy-success-header">
        <div className="back-button" onClick={() => navigate(`/dashboard${search}`)}>
          <LeftArrow /> Go Back
        </div>
        <div className="title-container">
          <div className="success-icon-container">✅</div>
          <div className="title">We look forward to speaking with you!</div>
          <div className="sub-title">
            Your strategy session is booked! Expect an email confirmation shortly. Before we speak, play around with the
            software so we don’t make it a demo call.
            <br />
            Watch this short video to learn more about what to expect next:
          </div>
        </div>
      </div>
      <div ref={videoContainerRef} className="strategy-success-video-box">
        <CustomVideoPlayer videoId={868272164} width={videoContainerRef.current?.clientWidth} />
      </div>
    </div>
  );
};

export default BookingSuccess;
